// React
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'

// Libraries

// Components
import BServices from 'shop-components/components/MiniCart/styles/Services'
import Checkbox from 'ui/components/Checkbox'
import ProductPrice from 'store/v2/react/components/product_price'

// Shared
import cartActions from 'store/v2/redux/actions/cart'
import { triggerUserFrameworkBookEvent } from 'shared/utils/userFrameworkEvents'

export const Service = ({ inCart, toggleService, service, line, hasPrice }) => {
  const [checked, setChecked] = useState(inCart)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (inCart !== checked) {
      setChecked(inCart)
    }
  }, [inCart, checked])

  const handleChangeService = () => {
    if (loading) return

    const value = !checked

    setChecked((prev) => !prev)
    setLoading(true)

    toggleService(service.id, value).catch(() => {
      setChecked((prev) => !prev)
    }).finally(() => {
      setLoading(false)
    })
  }

  const renderPrice = () => {
    return (
      <ProductPrice
        chargeLabel={(line || service).charge_label}
        priceInCents={line?.display_price_in_cents || service?.price_in_cents}
        priceType={(line || service).price_type}
        productType={(line || service).product_type}
      />
    )
  }

  return (
    <BServices.Service>
      <span>
        <Checkbox
          id={service.id}
          field={{
            value: checked,
            onChange: handleChangeService
          }}
          disabled={loading}
        />
      </span>
      <span onClick={handleChangeService}>{service.name}</span>
      {hasPrice && <span className="price">{renderPrice()}</span>}
    </BServices.Service>
  )
}

Service.displayName = 'Service'
Service.propTypes = {
  service: PropTypes.object.isRequired,
  line: PropTypes.object,
  inCart: PropTypes.bool.isRequired,
  toggleService: PropTypes.func.isRequired,
  hasPrice: PropTypes.bool
}

const mapStateToProps = (_state, props) => {
  const hasPrice =
    props.service &&
    props.service.price_in_cents >= 0 &&
    props.service.price_in_cents !== null &&
    props.service.price_type !== 'none'

  return {
    line: props.lines.getAll({ item_id: props.service.id }).reverse().first(),
    hasPrice
  }
}

const mapDispatchToProps = (_state, props) => {
  const book = (id, quantity) => {
    return cartActions
      .book({
        item_id: id,
        quantity,
        type: 'set'
      })
      .then(() => {
        const quantityChange = quantity === 0 ? -1 : 1

        triggerUserFrameworkBookEvent(props.service.id, quantityChange)
      })
  }

  return {
    toggleService: (id, value) => {
      if (value) {
        return book(id, 1)
      } else {
        return book(id, 0)
      }
    }
  }
}

export default reduxConnect(mapStateToProps, mapDispatchToProps)(Service)
